module.exports = __webpack_public_path__ + "static/media/redux.c62e7fbf.png";